"use strict";

var _utils = require("../utils");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _reactSweetProgress = require("react-sweet-progress"),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit"),
    _vars = require("@devsta/ui-kit/dist/common/styles/vars");

require("react-sweet-progress/lib/style.css");

require("../styles/_progress.scss");

var progressTheme = function progressTheme(errorIcon) {
  return {
    default: {
      symbol: " "
    },
    active: {
      symbol: " ",
      color: _vars.COLOURS.cyan.jungleGreen.monkey
    },
    success: {
      symbol: _react["default"].createElement(_uiKit.Icon, {
        name: "success",
        size: 12,
        color: "monkey"
      }),
      color: _vars.COLOURS.cyan.jungleGreen.monkey
    },
    error: {
      symbol: errorIcon,
      color: _vars.COLOURS.red.redApple
    }
  };
};

function ProgressSummary(_ref) {
  var loadedPercent = _ref.loadedPercent,
      loaded = _ref.loaded,
      total = _ref.total,
      removeUploadItem = _ref.removeUploadItem,
      hover = _ref.hover,
      status = _ref.status,
      hideProgressValue = _ref.hideProgressValue,
      errorIcon = hover ? _react["default"].createElement(_uiKit.Icon, {
    name: "trash",
    size: 17,
    color: "regent",
    onClick: removeUploadItem
  }) : _react["default"].createElement(_uiKit.Icon, {
    name: "alert",
    size: 17,
    color: "redApple"
  });
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_reactSweetProgress.Progress, {
    theme: progressTheme(errorIcon),
    percent: loadedPercent,
    status: 100 === loadedPercent && "error" !== status ? void 0 : status,
    className: (0, _classnames["default"])("progress", {
      "progress__hide-status": hideProgressValue || 100 !== loadedPercent && "error" !== status
    })
  }), hideProgressValue ? null : _react["default"].createElement("span", {
    className: (0, _classnames["default"])("progress__value", {
      "progress__value--none": 0 === loaded
    })
  }, "".concat((0, _utils.getUploadProgress)(loaded, total))));
}

var _default = (0, _react.memo)(ProgressSummary);

exports["default"] = _default;